import { c as _c } from "react/compiler-runtime";
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api';
import { NewsletterFilterInterface } from 'modules/newsletters/single/types/newsletter-filter-interface';
import { NewsletterApiInterface } from 'modules/newsletters/single/types/newsletter-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
interface UseNewslettersInterface extends SwrPaginationInterface {
  filter: NewsletterFilterInterface;
}
export function useNewsLetters(t0) {
  const $ = _c(14);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.search !== "" ? `&filter[searchBy]=${encodeURIComponent(filter.search)}` : ""}`;
  let t2;
  if ($[1] !== filterApi || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${NEWSLETTERS_API}/list?pagination[limit]=${limit}${filterApi}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${NEWSLETTERS_API}/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`;
        }
      }
      return null;
    };
    $[1] = filterApi;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      revalidateIfStale: true
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: newsletters,
    mutate
  } = useSWR(t2, fetcher, t3);
  let t4;
  if ($[7] !== filterApi || $[8] !== user) {
    t4 = () => {
      if (user) {
        return `${NEWSLETTERS_API}/count?pagination[limit]${filterApi}`;
      }
      return null;
    };
    $[7] = filterApi;
    $[8] = user;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    data: counter
  } = useSWR(t4, baseFetcher);
  let t5;
  if ($[10] !== counter || $[11] !== mutate || $[12] !== newsletters) {
    t5 = {
      newsletters,
      mutate,
      counter
    };
    $[10] = counter;
    $[11] = mutate;
    $[12] = newsletters;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}